import { NavLink } from './nav-link';
import { NavGroup } from './nav-group';

export enum NAV_ITEM_TYPE {
  Link,
  Group,
}

export type NavItemType = NavItemBase | NavLink | NavGroup;

export abstract class NavItemBase {
  /**
   * The text to display
   */
  label: string;

  private _breadcrumbLabel: string;

  /**
   * The text to display on the breadcrumbs when this item is part of the url.
   * If not set takes the value from the label.
   */
  get breadcrumbLabel(): string {
    return this._breadcrumbLabel || this.label;
  }

  set breadcrumbLabel(value: string) {
    this._breadcrumbLabel = value;
  }

  /**
   * An icon name to display with the label.
   */
  icon?: string;

  /**
   * The position of the item in it's group.
   */
  ordinal?: number;

  /**
   * The direction to add the item from.
   * Available values: 'top', 'bottom'.
   * Default is top
   */
  direction: string;

  /**
   * The type of the item.
   */
  readonly type: NAV_ITEM_TYPE;

  /**
   * The parent of this item, if null the item has no parent.
   */
  readonly parent?: NavItemBase;

  get hasOrdinal(): boolean {
    return this.ordinal >= 0;
  }

  get pinToBottom(): boolean {
    return this.direction === 'bottom';
  }
  /**
   * The URL from root ancestor to this NavItem.
   */
  abstract get url(): string;

  /** Will disable the menu item */
  disabled: boolean = false;

  constructor(type: NAV_ITEM_TYPE, parent?: NavItemBase) {
    this.type = type;

    if (parent) {
      this.parent = parent;
    }
  }
}
